import { render } from "./admin-scheduling.svg?vue&type=template&id=3451b561"
const script = {}
script.render = render

export default script